import Markdown from "react-native-markdown-display";
import { Link } from "expo-router";
import { Button } from "@ptsd/uikit";
import { Separator, Text, View, XStack } from "tamagui";

export const GuestErrorScreen = ({
  text,
  title,
  withBackBtn,
}: {
  text: string;
  title?: string;
  withBackBtn: boolean;
}) => {
  return (
    <View width={"100%"} paddingTop={"$15"} gap={"$3"} maxWidth={413}>
      <View width={"100%"} gap={"$2"}>
        <Text
          fontFamily={"$subtitle"}
          fontWeight={"$6"}
          fontSize={"$7"}
          lineHeight={"$7"}
        >
          {title ?? "Щось пішло не так 🤕"}
        </Text>

        <Markdown
          style={{
            body: {
              fontFamily: "Fixel Text",
              fontSize: 18,
              lineHeight: 22,
            },
          }}
        >
          {text}
        </Markdown>
      </View>
      {withBackBtn && (
        <>
          <Separator borderColor={"$gray-200"} />
          <XStack gap={"$1"}>
            <Link href={"/"} asChild>
              <Button
                variant="primary"
                width={"100%"}
                size="lg"
                rounded="lg"
                flex={1}
              >
                На Головну
              </Button>
            </Link>
          </XStack>
        </>
      )}
    </View>
  );
};
